import { useContext, useRef } from 'react';
import { SwitchTransition, Transition } from 'react-transition-group';
import { useRouter } from 'next/router';
import gsap from 'gsap/dist/gsap';

import TransitionContext from '../context/TransitionContext';

const TransitionComponent = ({ children }) => {
  const router = useRouter();
  const { toggleCompleted } = useContext(TransitionContext);
  const nodeRef = useRef(null);

  return (
    <SwitchTransition>
      <Transition
        key={router.pathname}
        timeout={500}
        nodeRef={nodeRef}
        onEnter={() => {
          const node = nodeRef.current;
          if (!node) return;
          toggleCompleted(false);
          gsap.set(node, {
            autoAlpha: 0
          });
          gsap
            .timeline({
              paused: true,
              onComplete: () => toggleCompleted(true)
            })
            .to(node, { autoAlpha: 1, duration: 0.25 })
            .play();
        }}
        onExit={() => {
          const node = nodeRef.current;
          if (!node) return;
          gsap
            .timeline({ paused: true })
            .to(node, { duration: 0.2 })
            .to(node, {
              autoAlpha: 0,
              duration: 0.2
            })
            .play();
        }}
      >
        <div ref={nodeRef}>{children}</div>
      </Transition>
    </SwitchTransition>
  );
};

export default TransitionComponent;
